<template>
  <div id="Users">
    <MyBanner :text="$t('banner.usersPage')" />
    <MyHeaderPage :title="$t('users.title')" subtitle="" />
    <br />

    <div class="mdl-tabs mdl-js-tabs mdl-js-ripple-effect">
      <div class="mdl-tabs__tab-bar">
        <span
          class="mdl-tabs__tab tabOne"
          id="tabOne"
          :class="{ 'is-active': ctrlPerms(['utenti']) }"
          @click="setTab(1)"
          v-if="ctrlPerms(['utenti'])"
          >{{ $t("users.tabOne") }}
          <div class="line"></div>
        </span>
        <span
          class="mdl-tabs__tab tabTwo"
          id="tabTwo"
          @click="setTab(2)"
          :class="{ 'is-active': !ctrlPerms(['utenti']) }"
          v-if="ctrlPerms(['ruoli'])"
          >{{ $t("users.tabTwo") }}
          <div class="line"></div
        ></span>
      </div>

      <div
        class="mdl-tabs__panel tabOne"
        :class="{ 'is-active': ctrlPerms(['utenti']) }"
      >
        <div class="mdl-grid">
          <div
            class="mdl-cell mdl-cell--4-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
          >
            <div class="contentInputFilter">
              <div class="contentIcon">
                <span class="material-icons">search</span>
              </div>
              <div class="contentInput">
                <input
                  type="text"
                  :placeholder="$t('users.searchUsers')"
                  @keyup="searchByString"
                  v-model="searchString"
                />
              </div>
            </div>
          </div>
          <div
            class="mdl-cell mdl-cell--2-col mdl-cell--4-offset mdl-cell--12-col-tablet mdl-cell--12-col-phone"
            v-if="isAdmin"
          >
            <download-csv
              :data="usersCsv"
              :name="$t('users.tabOne')"
              :delimiter="';'"
              :labels="{
                first_name: $t('users.nameUser'),
                last_name: $t('users.surNameUser'),
                email: $t('users.emailUser'),
                secondary_email: $t('users.emailTwoUser'),
                phone: $t('users.phoneUser'),
                enabled: $t('users.status'),
                group: $t('users.group'),
              }"
            >
              <button class="cdlButton">
                <img src="@/assets/img/download.png" alt="icon" />
                {{ $t("users.downLoadCSV") }}
              </button>
            </download-csv>
          </div>
          <div
            class="mdl-cell mdl-cell--2-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
          >
            <div>
              <button
                class="cdlButtonGreen"
                id="btnAddUser"
                @click="addUser()"
                v-if="isAdmin && ctrlPerms(['utenti'])"
                style="font-size: 1.2rem"
              >
                {{ $t("users.newUser") }}
              </button>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--12-col">
            <div class="mdl-grid tableUsers">
              <div
                class="mdl-cell mdl-cell--3-col mdl-cell--2-col-tablet mdl-cell--2-col-phone title"
              >
                {{ $t("users.tableNameSurname") }}
              </div>
              <div class="mdl-cell mdl-cell--3-col title" v-if="!IsMobile">
                {{ $t("users.tableEmail") }}
              </div>
              <div class="mdl-cell mdl-cell--2-col title" v-if="!IsMobile">
                {{ $t("users.tablePhone") }}
              </div>
              <div
                class="mdl-cell mdl-cell--2-col mdl-cell--4-col-tablet mdl-cell--2-col-phone title"
              >
                {{ $t("users.tableRole") }}
              </div>
              <div class="mdl-cell mdl-cell--1-col" v-if="!IsMobile"></div>
              <div
                class="mdl-cell mdl-cell--1-col title biometricTitle"
                v-if="!IsMobile"
              >
                {{ $t("users.tableBiometric") }}
              </div>
            </div>
            <MyLoading :viewLoader="viewLoader" type="" />
            <div>
              <div
                class="mdl-grid tableUsers"
                v-for="(user, n) in dataFilter"
                :key="n"
                :class="{ disable: !user.enabled }"
                :id="['user-' + user.first_name.replace(' ', '-')]"
              >
                <div
                  class="mdl-cell mdl-cell--3-col mdl-cell--2-col-tablet mdl-cell--2-col-phone contentTableUsers"
                >
                  {{ user.last_name }} {{ user.first_name }}
                </div>
                <div
                  class="mdl-cell mdl-cell--3-col contentTableUsers"
                  v-if="!IsMobile"
                >
                  {{ user.email }}
                </div>
                <div
                  class="mdl-cell mdl-cell--2-col contentTableUsers"
                  v-if="!IsMobile"
                >
                  {{ user.phone }}
                </div>
                <div
                  class="mdl-cell mdl-cell--2-col mdl-cell--4-col-tablet mdl-cell--2-col-phone contentTableUsers"
                >
                  <div
                    class="cdlChip mdl-grid"
                    :class="[
                      'chipColor-' +
                        getColorRole(user.role.color.toLowerCase()),
                    ]"
                  >
                    <div class="mdl-cell mdl-cell--2-col">
                      <div class="circleRole"></div>
                    </div>
                    <div class="mdl-cell mdl-cell--8-col">
                      <span class="nameRole">{{ user.role.name }}</span>
                    </div>
                  </div>
                </div>
                <div
                  class="mdl-cell mdl-cell--1-col mdl-cell--2-col-tablet mdl-cell--2-col-phone"
                  style="text-align: center"
                >
                  <span
                    @click="editInfo(n)"
                    :id="['user-edit-' + user.first_name.replace(' ', '-')]"
                    v-if="isAdmin"
                    class="editInfo material-icons"
                    v-tooltip:bottom.tooltip="$t('users.editUser')"
                  >
                    edit
                  </span>
                </div>
                <div
                  class="mdl-cell mdl-cell--1-col mdl-cell--2-col-tablet mdl-cell--2-col-phone actionCell"
                >
                  <div class="userActionButtons">

                    <div
                      class="menuEditUser"
                      :class="['menuEditUser-' + n]"
                      @click="viewUser(n)"
                      :id="['user-more-' + user.first_name.replace(' ', '-')]"
                    >
                      <i class="material-icons">more_vert</i>
                    </div>

                    <div class="biometricWrapper" v-show="showBiometric">
                      <div
                        class="menuEditUser biometricTrigger"
                        :id="[
                          'user-fingerprint-' +
                            user.first_name.replace(' ', '-'),
                        ]"
                        @click="user.enabled && isColocation && viewBiometric(n)"
                        v-tooltip:top.tooltip="getBiometricLegendTooltip()"
                        :style="{
                          opacity: user.enabled && isColocation ? '1' : '0.5',
                          cursor: user.enabled && isColocation ? 'pointer' : 'not-allowed',
                        }"
                      >
                        <i class="material-icons">fingerprint</i>
                        <div
                          class="biometricStatusDot"
                          :style="{
                            backgroundColor: getBiometricDotColor(user),
                          }"
                        ></div>

                      </div>
                      <div
                        class="subInfoBiometric"
                        :class="['subInfoBiometric-' + n]"
                      >
                        <div
                          @click="
                            user.enabled &&
                              !user.is_biometric &&
                              !isBiometricPending(user) &&
                              requestBiometricAccess(n)
                          "
                          :id="[
                            'user-request-biometric-' +
                              user.first_name.replace(' ', '-'),
                          ]"
                          :style="{
                            opacity:
                              !user.enabled ||
                              user.is_biometric ||
                              isBiometricPending(user)
                                ? '0.5'
                                : '1',
                            cursor:
                              !user.enabled ||
                              user.is_biometric ||
                              isBiometricPending(user)
                                ? 'not-allowed'
                                : 'pointer',
                          }"
                        >
                          <span class="material-icons">add_circle</span>
                          <span class="biometric-text">{{
                            $t("users.biometricRequestText")
                          }}</span>
                        </div>
                        <div
                          @click="
                            user.enabled &&
                              user.is_biometric &&
                              !isBiometricPending(user) &&
                              revokeBiometricAccess(n)
                          "
                          :id="[
                            'user-revoke-biometric-' +
                              user.first_name.replace(' ', '-'),
                          ]"
                          :style="{
                            opacity:
                              !user.enabled ||
                              !user.is_biometric ||
                              isBiometricPending(user)
                                ? '0.5'
                                : '1',
                            cursor:
                              !user.enabled ||
                              !user.is_biometric ||
                              isBiometricPending(user)
                                ? 'not-allowed'
                                : 'pointer',
                          }"
                        >
                          <span class="material-icons fingerprint-off"
                            >remove_circle</span
                          >
                          <span class="biometric-text">{{
                            $t("users.biometricRevokeText")
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="subInfoUser" :class="['subInfoUser-' + n]">
                    <div
                      @click="openDetailsUser(n)"
                      :id="[
                        'user-details-' + user.first_name.replace(' ', '-'),
                      ]"
                    >
                      <span class="material-icons">person</span>
                      {{ $t("users.profile") }}
                    </div>
                    <div
                      @click="openModal(n)"
                      :id="['user-delete-' + user.first_name.replace(' ', '-')]"
                      v-if="user.email != userLogged.email && isAdmin"
                    >
                      <span class="material-icons">delete</span>
                      {{ $t("users.deleteUser") }}
                    </div>
                    <div
                      @click="disableAbilityUser(n)"
                      :id="[
                        'user-disable-' + user.first_name.replace(' ', '-'),
                      ]"
                      v-if="user.email != userLogged.email && isAdmin"
                    >
                      <span class="material-icons">person_off</span>
                      {{
                        user.enabled
                          ? $t("users.disableUser")
                          : $t("users.abilityUser")
                      }}
                    </div>
                    <!--<div>Prova</div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- GROUP -->
      <div
        class="mdl-tabs__panel tabTwo"
        :class="{ 'is-active': !ctrlPerms(['utenti']) }"
      >
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--4-col">
            <div class="contentInputFilter">
              <div class="contentIcon">
                <span class="material-icons">search</span>
              </div>
              <div class="contentInput">
                <input
                  type="text"
                  :placeholder="$t('users.searchRoles')"
                  @keyup="searchGroupByString"
                  v-model="searchGroupString"
                />
              </div>
            </div>
          </div>
          <div
            class="mdl-cell mdl-cell--2-col mdl-cell--4-offset"
            v-if="isAdmin"
          >
            <download-csv
              :data="groupsCsv"
              :name="$t('users.tabTwo')"
              :delimiter="';'"
            >
              <button
                class="cdlButton"
                :labels="{
                  id: 'id',
                  name: $t('users.tabTwo'),
                  permissions: $t('users.permissions'),
                }"
              >
                <img src="@/assets/img/download.png" alt="icon" />
                {{ $t("users.downLoadCSV") }}
              </button>
            </download-csv>
          </div>
          <div class="mdl-cell mdl-cell--2-col">
            <div>
              <button
                class="cdlButtonGreen"
                @click="addGroup()"
                id="addGroup"
                v-if="isAdmin && ctrlPerms(['ruoli'])"
                style="font-size: 1.2rem"
              >
                {{ $t("users.btnNewRoleTwo") }}
              </button>
            </div>
          </div>
        </div>
        <div class="mdl-cell mdl-cell--12-col">
          <div class="mdl-grid">
            <!-- CARD -->
            <div
              class="mdl-cell mdl-cell--4-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
              v-for="(group, n) in dataFilterGroups"
              :key="n"
            >
              <div class="cardRole heightCardRole">
                <div
                  class="mdl-grid"
                  style="align-items: center; padding: 5px 20px 0px 5px"
                >
                  <div class="mdl-cell mdl-cell--2-col">
                    <div
                      class="colorRole"
                      :class="[
                        'color-' + getColorRole(group.color.toLowerCase()),
                      ]"
                    ></div>
                  </div>
                  <div class="mdl-cell mdl-cell--7-col">
                    <span class="nameRoleCard firstUpper">
                      {{ group.name }}
                    </span>
                  </div>
                  <div
                    class="mdl-cell mdl-cell--3-col"
                    style="display: inline-flex; justify-content: flex-end"
                  >
                    <div v-if="noEdit(group.name) && isAdmin">
                      <span
                        @click="editGroup(n)"
                        :id="['role-edit-' + group.name.replace(' ', '-')]"
                        class="material-icons editInfo"
                        v-tooltip:bottom.tooltip="$t('users.editUser')"
                      >
                        edit
                      </span>
                    </div>
                    <div v-if="isAdmin" style="margin-left: 10px">
                      <i
                        class="menuEditRole material-icons"
                        :class="['menuEditRole-' + n]"
                        @click="viewGroup(n)"
                        :id="['role-more-' + group.name.replace(' ', '-')]"
                        >more_vert</i
                      >
                    </div>
                    <div class="subInfoRole" :class="['subInfoRole-' + n]">
                      <div
                        @click="addUsersGroup(n)"
                        :id="['role-add-users-' + group.name.replace(' ', '-')]"
                      >
                        <span class="material-icons">person</span>
                        {{ $t("users.associateUser") }}
                      </div>
                      <div
                        @click="
                          !group || (group && group.user_count == 0)
                            ? deleteGroup(group.id)
                            : null
                        "
                        :id="['role-delete-' + group.name.replace(' ', '-')]"
                        v-if="noEdit(group.name) && isAdmin"
                        v-tooltip:bottom.tooltip="
                          !(!group || (group && group.user_count == 0))
                            ? $t('users.deleteGroupTooltip')
                            : ''
                        "
                      >
                        <span
                          style="display: flex; justify-content: center"
                          :class="{
                            opacity: !(
                              !group ||
                              (group && group.user_count == 0)
                            ),
                          }"
                        >
                          <span class="material-icons">delete</span>
                          {{ $t("users.deleteGroup") }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- END EDIT BTN -->
                </div>
                <div class="mdl-grid">
                  <div class="mdl-cell mdl-cell--10-col mdl-cell--2-offset">
                    <span class="textCardRole">{{ $t("users.areaRole") }}</span>

                    <!-- START PERMISSIONS LIST -->
                    <div
                      style="
                        min-height: 220px;
                        max-height: 220px;
                        overflow: hidden;
                        overflow-y: auto;
                      "
                    >

                      <div
                        v-for="(permission, keyPermissions) in menu"
                        :key="keyPermissions"
                      >
                        <div :class="['groupIndex-' + keyPermissions]">
                          <div
                            class="itemGroup"
                            @click="
                              openChild('p-' + keyPermissions, '', '', group.id)
                            "
                            v-if="
                              getPermissionForDirectUser(
                                permission.name,
                                'area_partner'
                              ) &&
                              checkPermissions(
                                permission.permissions,
                                group.pages,
                                true
                              )
                            "
                          >
                            <i
                              class="material-icons arrow"
                              :class="[
                                group.id + '-arrow-p-' + keyPermissions,
                                permission.child ? '' : 'opacity',
                              ]"
                              >arrow_right</i
                            >

                            <span class="firstUpper">{{
                              $t(permission.label)
                            }}</span>
                          </div>
                          <!-- account -->
                          <div
                            v-for="(pages, keyPages) in permission.child"
                            :key="keyPages"
                            class="contentSubElems child"
                            :class="[group.id + '-child-p-' + keyPermissions]"
                          >
                            <div class="block">
                              <div class="border"></div>
                              <div>
                                <div
                                  class="itemGroup"
                                  @click="
                                    openChild(
                                      'p-' + keyPermissions + '-' + keyPages,
                                      '',
                                      '',
                                      group.id
                                    )
                                  "
                                  v-if="
                                    checkPermissions(
                                      pages.permissions,
                                      group.pages,
                                      true
                                    )
                                  "
                                >
                                  <span
                                    class="material-icons arrow"
                                    :class="[
                                      group.id +
                                        '-arrow-p-' +
                                        keyPermissions +
                                        '-' +
                                        keyPages,
                                      pages.child ? '' : 'opacity',
                                    ]"
                                    >arrow_right</span
                                  >

                                  <span class="firstUpper">{{
                                    $t(pages.label)
                                  }}</span>
                                </div>
                                <div
                                  v-for="(type, keytype) in pages.child"
                                  :key="keytype"
                                  class="childChild"
                                  :class="[
                                    group.id +
                                      '-child-p-' +
                                      keyPermissions +
                                      '-' +
                                      keyPages,
                                  ]"
                                >
                                  <div class="contentSubElems">
                                    <div class="block">
                                      <div class="borderUnion"></div>
                                      <div
                                        class="itemGroup"
                                        @click="
                                          openChild(
                                            'p-' + keyPermissions,
                                            keyPermissions,
                                            keytype,
                                            group.id
                                          )
                                        "
                                        v-if="
                                          checkPermissions(
                                            type.permissions,
                                            group.pages,
                                            type.child && type.child.length > 0
                                          )
                                        "
                                      >
                                        <span
                                          class="material-icons arrow"
                                          :class="[
                                            group.id +
                                              '-arrow-p-' +
                                              keyPermissions +
                                              '-' +
                                              keyPermissions +
                                              '-' +
                                              keytype,
                                            type.child ? '' : 'opacity',
                                          ]"
                                          >arrow_right</span
                                        >

                                        <span class="firstUpper">{{
                                          $t(type.label)
                                        }}</span>
                                      </div>
                                    </div>

                                    <div
                                      v-for="(
                                        singlePage, keySinglePage
                                      ) in type.child"
                                      :key="keySinglePage"
                                      class="childChildPage"
                                      :class="[
                                        group.id +
                                          '-child-p-' +
                                          keyPermissions +
                                          '-' +
                                          keyPermissions +
                                          '-' +
                                          keytype,
                                      ]"
                                    >
                                      <div
                                        class="contentSubElems"
                                        v-if="
                                          getPermissionForDirectUser(
                                            singlePage.name,
                                            'verifica_copertura'
                                          ) &&
                                          checkPermissions(
                                            singlePage.permissions || [
                                              singlePage.name,
                                            ],
                                            group.pages
                                          )
                                        "
                                      >
                                        <div class="block">
                                          <div class="borderUnion"></div>
                                          <div class="itemGroup">
                                            <span class="firstUpper">{{
                                              $t(singlePage.label)
                                            }}</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <br /><br />
                    <span class="textCardRole">{{
                      $t("users.usersRole")
                    }}</span>
                    <p style="margin: 0">
                      <span class="nUsersRole">{{ group.user_count }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- FINE CARD -->
          </div>
        </div>
      </div>
    </div>

    <keep-alive>
      <component
        :is="panels[panel]"
        :view="viewPanel"
        @close-panel="openPanel"
        :singleUser="singleUser"
        :groups="groups"
        :singleGroup="singleGroup"
        @edit-info-from-details="editInfoFromDetails"
        @disable-ability-user="disableAbilityUser"
        :allUsers="users"
        @delete-user="deleteUser"
        @open-users-group="openUsersGroup"
        @confirm-user-group="confirmUsersGroup"
        :usersGroup="usersGroup"
        @reset-users-group="resetUsersGroup"
        @open-role="openRole"
        :ctrlPanelUsersSearch="ctrlPanelUsersSearch"
        :ctrlPanelUsersSearchFromGroup="ctrlPanelUsersSearchFromGroup"
        :userLogged="userLogged"
        @open-modal="openModal"
        :pages="pages"
      >
      </component>
    </keep-alive>
  </div>
  <DeleteModal
    :show-modal="viewModal"
    :title="$t('users.titleDelete')"
    :subtitle="
      $t('users.subTitleDelete', {
        name: singleUser?.first_name + ' ' + singleUser?.last_name,
      })
    "
    :text="$t('users.textDelete')"
    :delete-button-text="$t('users.btnDelete')"
    :revert-delete-text="$t('users.revertDelete')"
    @delete="deleteUser(singleUser.ctrl)"
    @close="closeModal()"
  />
  <DeleteModal
    :show-modal="viewBiometricRequestModal"
    :title="$t('users.biometricRequestTitle')"
    :subtitle="
      $t('users.biometricRequestSubtitle', {
        firstName: singleUser?.first_name,
        lastName: singleUser?.last_name,
        company: userLogged?.account?.business_name || '',
      })
    "
    :text="$t('users.biometricConfirmText')"
    :delete-button-text="$t('users.biometricYes')"
    :revert-delete-text="$t('users.biometricNo')"
    :biometric-modal="true"
    @delete="confirmBiometricRequest()"
    @close="closeBiometricRequestModal()"
  />
  <DeleteModal
    :show-modal="viewBiometricRevokeModal"
    :title="$t('users.biometricRevokeTitle')"
    :subtitle="
      $t('users.biometricRevokeSubtitle', {
        firstName: singleUser?.first_name,
        lastName: singleUser?.last_name,
      })
    "
    :delete-button-text="$t('users.biometricYes')"
    :revert-delete-text="$t('users.biometricNo')"
    :biometric-modal="true"
    @delete="confirmBiometricRevoke()"
    @close="closeBiometricRevokeModal()"
  />
</template>

<script setup>
import { computed } from "vue";
import { useUserStore } from "@/stores/UserStore";
import DeleteModal from "@/components/modals/DeleteModal.vue";

const userLogged = computed(() => {
  return useUserStore().user;
});
</script>

<script>
import MyBanner from "@/components/MyBanner.vue";
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import ManagementUser from "@/components/Users/ManagementUser.vue";
import ManagementRole from "@/components/Users/ManagementRole.vue";
import UsersRole from "@/components/Users/UsersRole.vue";
import DetailsUser from "@/components/Users/DetailsUser.vue";
import SearchUser from "@/components/Users/SearchUser.vue";
import "@/assets/scss/Users.scss";
import downloadCsv from "vue-json-csv";
import MyLoading from "@/components/MyLoading.vue";
import menuJson from "@/configs/menu.json";

// import { useUserStore } from '@/stores/UserStore'

export default {
  name: "MyUsers",
  components: {
    MyBanner,
    MyHeaderPage,
    ManagementUser,
    ManagementRole,
    UsersRole,
    DetailsUser,
    SearchUser,
    downloadCsv,
    MyLoading,
  },
  data() {
    return {
      viewPanel: false,
      IsMobile: this.$IsMobile(),
      users: [],
      dataFilter: [],
      usersCsv: [],
      groups: [],
      dataFilterGroups: [],
      singleUser: {},
      singleGroup: {},
      usersGroup: [],
      panel: 0,
      showBiometric : false,
      panels: [
        "ManagementUser",
        "ManagementRole",
        "UsersRole",
        "DetailsUser",
        "SearchUser",
      ],
      searchString: "",
      searchGroupString: "",
      ctrlPanelUsersSearch: false,
      ctrlPanelUsersSearchFromGroup: false,
      viewModal: false,
      viewBiometricRequestModal: false,
      viewBiometricRevokeModal: false,
      viewLoader: false,
      isAdmin: false,
      menu: menuJson,
      he: {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      },
      pages: [],
    };
  },
  computed: {
    isColocation() {
      return useUserStore().user.isColocation;
    },
  },
  methods: {
    setTab(tab) {
      if (tab == 1) {
        document
          .getElementsByClassName("tabTwo")[0]
          .classList.remove("is-active");
        document
          .getElementsByClassName("tabTwo")[1]
          .classList.remove("is-active");
        document.getElementsByClassName("tabOne")[0].classList.add("is-active");
        document.getElementsByClassName("tabOne")[1].classList.add("is-active");
      } else {
        if (Object.keys(this.singleUser).length > 0) {
          this.singleUser = {};
        }

        document.getElementsByClassName("tabTwo")[0].classList.add("is-active");
        document.getElementsByClassName("tabTwo")[1].classList.add("is-active");
        document
          .getElementsByClassName("tabOne")[0]
          .classList.remove("is-active");
        document
          .getElementsByClassName("tabOne")[1]
          .classList.remove("is-active");
      }
    },
    openPanel(value) {
      this.panel = value.whichPanel;

      if (value.whichPanel != 4) {
        this.viewPanel = !this.viewPanel;
      }

      if (!this.viewPanel) {
        setTimeout(() => {
          this.getGroups();
          this.getUsers(true);
        }, 1000);
      }

      this.viewUser();
      this.viewGroup();

      if (
        Object.keys(this.singleUser).length > 0 &&
        value.whoUpdate == 2 &&
        this.panel == 1
      ) {
        this.panel = 0;
        this.viewPanel = !this.viewPanel;
      }
    },
    addUser() {
      this.singleUser = {};
      this.openPanel({ whichPanel: 0 });
    },
    searchByString() {
      if (this.searchString.length == 0) {
        this.getUsers();
        return;
      }

      this.dataFilter = [];
      this.users.forEach((elm) => {
        if (
          elm.first_name
            .toLowerCase()
            .includes(this.searchString.toLowerCase()) ||
          elm.last_name
            .toLowerCase()
            .includes(this.searchString.toLowerCase()) ||
          elm.email.toLowerCase().includes(this.searchString.toLowerCase()) ||
          (elm.phone &&
            elm.phone.toLowerCase().includes(this.searchString.toLowerCase()))
        ) {
          this.dataFilter.push(elm);
        }
      });

      this.buildCsv();
    },
    searchGroupByString() {
      if (this.searchGroupString.length == 0) {
        this.getGroups();
        return;
      }

      this.dataFilterGroups = [];
      this.groups.forEach((elm) => {
        if (
          elm.name.toLowerCase().includes(this.searchGroupString.toLowerCase())
        ) {
          this.dataFilterGroups.push(elm);
        }
      });

      this.buildGroupsCsv();
    },
    async editInfo(index) {
      const user = this.dataFilter[index];

      if (!user || !user.id) {
        console.warn("Cannot edit user: missing user data or id", user);
        return;
      }

      const currentPanel = this.panel;

      if (!this.viewPanel) {
        this.openPanel({ whichPanel: 0 });
      } else if (currentPanel !== 0) {
        this.panel = 0;
      }

      this.singleUser = {};

      try {
        const response = await this.axios.get(
          window.VUE_APP_MISTRA_URL +
            "users/v2/user/" +
            user.id,
          {
            headers: this.he,
          }
        );

        const fullUser = response.data || {};
        const fallbackRoleId =
          fullUser.role_id ||
          user.role_id ||
          (user.role && user.role.id) ||
          (user.group && user.group.id);

        if (
          !fullUser.role &&
          fallbackRoleId &&
          Array.isArray(this.groups) &&
          this.groups.length > 0
        ) {
          const matchedGroup = this.groups.find(
            (group) => group.id === fallbackRoleId
          );

          if (matchedGroup) {
            fullUser.role = matchedGroup;
          }
        }

        if (!fullUser.role) {
          fullUser.role = user.role || user.group;
        }

        if (!fullUser.role && fallbackRoleId) {
          fullUser.role = { id: fallbackRoleId };
        }

        this.singleUser = fullUser;
      } catch (error) {
        console.error("Failed to load user details", error);
        const fallbackRoleId =
          user.role_id ||
          (user.role && user.role.id) ||
          (user.group && user.group.id);
        let fallbackRole = user.role || user.group || null;

        if (
          !fallbackRole &&
          fallbackRoleId &&
          Array.isArray(this.groups) &&
          this.groups.length > 0
        ) {
          fallbackRole = this.groups.find(
            (group) => group.id === fallbackRoleId
          );
        }

        if (!fallbackRole && fallbackRoleId) {
          fallbackRole = { id: fallbackRoleId };
        }

        this.singleUser = {
          ...user,
          role: fallbackRole,
        };
      }
    },
    editGroup(index) {
      console.log(index);
      this.singleGroup = this.dataFilterGroups[index];
      this.openPanel({ whichPanel: 1 });
    },
    editInfoFromDetails() {
      this.openPanel({ whichPanel: 3 });
      this.openPanel({ whichPanel: 0 });
    },
    openRole(ctrl = 0) {
      if (ctrl == 0) {
        this.singleUser = {};
      } else {
        // nuovo ruolo da crea utente
        this.singleGroup = {};
        this.usersGroup = {};
        this.singleUser = ctrl;
        this.viewPanel = !this.viewPanel;
        this.panel = 1;
        this.viewPanel = !this.viewPanel;
        return;
      }
      this.openPanel({ whichPanel: 0 });
      this.addGroup();
    },
    viewUser(index = -1) {
      let subInfoUser = document.getElementsByClassName("subInfoUser");

      for (let i = 0; i < subInfoUser.length; i++) {
        if (index != i) {
          subInfoUser[i].classList.remove("active");
        }
      }

      if (
        index > -1 &&
        document.getElementsByClassName("subInfoUser-" + index)[0]
      ) {
        if (
          document
            .getElementsByClassName("subInfoUser-" + index)[0]
            .classList.contains("active")
        ) {
          document
            .getElementsByClassName("subInfoUser-" + index)[0]
            .classList.remove("active");
        } else {
          document
            .getElementsByClassName("subInfoUser-" + index)[0]
            .classList.add("active");
        }
      }
    },
    viewGroup(index = -1) {
      const subInfoRole = document.getElementsByClassName("subInfoRole");

      // Close all other role menus
      for (let i = 0; i < subInfoRole.length; i++) {
        if (index != i) {
          subInfoRole[i].classList.remove("active");
        }
      }

      // Toggle current role menu
      const current = document.getElementsByClassName(
        "subInfoRole-" + index
      )[0];
      if (current) {
        const willOpen = !current.classList.contains("active");
        if (willOpen) {
          current.classList.add("active");
        } else {
          current.classList.remove("active");
        }
      }

      // Manage click-outside listener: add if any role menu is open; otherwise remove
      let anyOpen = false;
      for (let i = 0; i < subInfoRole.length; i++) {
        if (subInfoRole[i].classList.contains("active")) {
          anyOpen = true;
          break;
        }
      }
      if (anyOpen) {
        this.addRoleClickOutsideListener();
      } else {
        this.removeRoleClickOutsideListener();
      }
    },

    closeAllRoleMenus() {
      const subInfoRole = document.getElementsByClassName("subInfoRole");
      for (let i = 0; i < subInfoRole.length; i++) {
        subInfoRole[i].classList.remove("active");
      }
    },

    handleClickOutsideRoles(event) {
      // If click is inside a role dropdown or on its trigger, ignore
      const clickedInDropdown =
        event.target.closest && event.target.closest(".subInfoRole");
      const clickedOnTrigger =
        event.target.closest && event.target.closest(".menuEditRole");
      if (!clickedInDropdown && !clickedOnTrigger) {
        this.closeAllRoleMenus();
        this.removeRoleClickOutsideListener();
      }
    },

    addRoleClickOutsideListener() {
      if (!this._roleClickOutsideHandler) {
        this._roleClickOutsideHandler = (e) => this.handleClickOutsideRoles(e);
      }
      document.addEventListener("click", this._roleClickOutsideHandler);
    },

    removeRoleClickOutsideListener() {
      if (this._roleClickOutsideHandler) {
        document.removeEventListener("click", this._roleClickOutsideHandler);
      }
    },
    getUsers(noLoader = false) {
      this.viewLoader = noLoader;
      this.axios
        .get(
          window.VUE_APP_MISTRA_URL +
            "users/v2/user?page_number=1&disable_pagination=true",
          {
            headers: this.he,
          }
        )
        .then((response) => {
          const users = response.data.items || [];
          users.forEach((user) => {
            this.syncBiometricState(user);
          });
          this.users = users;
          this.dataFilter = this.users;
          if (this.searchString.length != 0) {
            this.searchByString();
          }
          this.buildCsv();
          this.viewLoader = true;
          this.getIsAdmin();
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    getGroups() {
      this.axios
        .get(
          window.VUE_APP_MISTRA_URL +
            "users/v2/role?page_number=1&disable_pagination=true",
          {
            headers: this.he,
          }
        )
        .then((response) => {
          this.groups = response.data.items;
          this.dataFilterGroups = this.groups;
          if (this.searchGroupString.length != 0) {
            this.searchGroupByString();
          }
          this.buildGroupsCsv();
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    openDetailsUser(index) {
      this.viewUser(index);
      this.singleUser = this.dataFilter[index];
      this.singleUser.index = index;
      this.openPanel({ whichPanel: 3 });
    },
    disableAbilityUser(ctrl = -1) {
      let user = this.singleUser;

      if (ctrl >= 0) {
        user = this.dataFilter[ctrl];
      }

      let what = user.enabled ? "disable" : "enable";

      this.axios
        .post(
          window.VUE_APP_MISTRA_URL +
            "users/v2/user/" +
            user.id +
            "/" +
            what,
          {},
          { headers: this.he }
        )
        .then(() => {
          if (ctrl == -1) {
            // Disabilito dal pannello dei dettagli utente
            this.openPanel({ whichPanel: 3, whoUpdate: 1 });
          } else {
            this.viewUser(ctrl);
            this.getUsers(true);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    deleteUser(ctrl = -1) {
      if (ctrl > -1) {
        this.singleUser = this.dataFilter[ctrl];
      }

      this.axios
        .delete(
          window.VUE_APP_MISTRA_URL +
            "users/v2/user/" +
            this.singleUser.id,
          { headers: this.he }
        )
        .then(() => {
          if (ctrl == -1) {
            // Elimino dal pannello dei dettagli utente
            this.openPanel({ whichPanel: 3, whoUpdate: 1 });
            return;
          }
          this.viewUser(ctrl);
          this.getUsers(true);
          this.getGroups();
          this.closeModal();
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    openModal(ctrl) {
      window.scrollTo(0, 0);
      this.singleUser = this.dataFilter[ctrl];
      this.singleUser.ctrl = ctrl;
      this.viewModal = true;
      if (this.viewModal) {
        document.getElementsByTagName("body")[0].classList.add("overflow");
      }
      this.viewUser();
    },
    closeModal() {
      this.singleUser = {};
      this.viewModal = false;
      document.getElementsByTagName("body")[0].classList.remove("overflow");
    },
    buildCsv() {
      this.usersCsv = this.dataFilter.map((elem) => ({
        first_name: elem.first_name,
        last_name: elem.last_name,
        email: elem.email,
        secondary_email: elem.secondary_email,
        phone: "'" + elem.phone + "'",
        enabled: elem.enabled ? "Attivo" : "Disattivato",
        group: elem.role.name,
      }));
    },
    buildGroupsCsv() {
      this.groupsCsv = [];
      this.dataFilterGroups.forEach((elem) => {
        let perm = [];
        elem.pages.forEach((page) => {
          perm.push(page.name);
        });
        // elem.permissions.forEach((elmFirstLevel) => {
        //   perm.push(elmFirstLevel.name);
        //   if (elmFirstLevel.children) {
        //     elmFirstLevel.children.forEach((elmSecondLevel) => {
        //       perm.push(elmSecondLevel.name);
        //       if (elmSecondLevel.children) {
        //         elmSecondLevel.children.forEach((elmThirdLevel) => {
        //           perm.push(elmThirdLevel.name);
        //           if (elmThirdLevel.children) {
        //             elmThirdLevel.children.forEach((elmFourthLevel) => {
        //               perm.push(elmFourthLevel.name);
        //             });
        //           }
        //         });
        //       }
        //     });
        //   }
        // });
        this.groupsCsv.push({
          name: elem.name,
          permissions: JSON.stringify(perm)
            .replaceAll('"', "")
            .replaceAll("[", "")
            .replaceAll("]", ""),
        });
      });
    },
    openChild(index, levelOne = "", levelTwo = "", group_id) {
      if (typeof levelOne != "string") {
        levelOne = "-" + levelOne;
        if (typeof levelTwo != "string") {
          levelOne += "-" + levelTwo;
        }
      }
      if (document.getElementsByClassName(group_id + "-child-" + index)[0]) {
        if (
          document
            .getElementsByClassName(group_id + "-child-" + index + levelOne)[0]
            .classList.contains("active")
        ) {
          let elms = document.getElementsByClassName(
            group_id + "-child-" + index + levelOne
          );
          for (let i = 0; i < elms.length; i++) {
            elms[i].classList.remove("active");
          }
          document
            .getElementsByClassName(group_id + "-arrow-" + index + levelOne)[0]
            .classList.remove("rotate");
        } else {
          let elms = document.getElementsByClassName(
            group_id + "-child-" + index + levelOne
          );
          for (let i = 0; i < elms.length; i++) {
            elms[i].classList.add("active");
          }
          document
            .getElementsByClassName(group_id + "-arrow-" + index + levelOne)[0]
            .classList.add("rotate");
        }
      }
    },
    addGroup() {
      this.singleGroup = {};
      this.usersGroup = [];
      this.openPanel({ whichPanel: 1 });
    },
    openUsersGroup() {
      this.ctrlPanelUsersSearchFromGroup = true;
      this.openPanel({ whichPanel: 4 });
    },
    confirmUsersGroup(value) {
      // Do not override current usersGroup immediately; compute union after fetching current members
      const dedupNew = [];
      const seenNew = new Set();
      (value && Array.isArray(value.users) ? value.users : []).forEach((u) => {
        if (u && typeof u.id !== "undefined" && !seenNew.has(u.id)) {
          seenNew.add(u.id);
          dedupNew.push(u);
        }
      });

      let usersCurrentGroup = new Promise((resolve, reject) => {
        if (!this.singleGroup.id) {
          return resolve(this.usersGroup || []);
        }
        let url =
          "users/v2/role/" +
          this.singleGroup.id +
          "/users?page_number=1&disable_pagination=true";
        this.axios
          .get(window.VUE_APP_MISTRA_URL + url, {
            headers: this.he,
          })
          .then((response) => {
            resolve(response.data.items ? response.data.items : []);
          })
          .catch(function (err) {
            reject(err);
          });
      });

      Promise.all([usersCurrentGroup]).then((values) => {
        if (values[0]) {
          const existing = Array.isArray(values[0]) ? values[0] : [];
          // Merge existing members with newly selected (add-only)
          const byId = new Map();
          existing.forEach((u) => {
            if (u && typeof u.id !== "undefined") byId.set(u.id, u);
          });
          dedupNew.forEach((u) => {
            if (u && typeof u.id !== "undefined") byId.set(u.id, u);
          });
          const merged = Array.from(byId.values());

          if (this.ctrlPanelUsersSearch) {
            // Reflect immediately in UI
            this.usersGroup = merged;
            this.ctrlPanelUsersSearch = false;
            const users_id = {
              users: merged.map((u) => u.id),
            };
            if (this.singleGroup.id) {
              this.axios.post(
                window.VUE_APP_MISTRA_URL +
                  "users/v2/role/" +
                  this.singleGroup.id +
                  "/users",
                users_id,
                { headers: this.he }
              );
            }

            setTimeout(() => {
              this.getGroups();
              this.getUsers(true);
            }, 500);

            this.viewGroup();
            // Stay on Role panel
            this.panel = 1;
            this.viewPanel = true;
            return;
          }

          if (this.ctrlPanelUsersSearchFromGroup) {
            this.ctrlPanelUsersSearchFromGroup = false;

            // Se sto creando il gruppo adesso
            if (!this.singleGroup.id) {
              // Only update local state; server update will occur on save
              this.usersGroup = merged;
            } else {
              // Update role users on server with merged (add-only)
              this.usersGroup = merged;
              const users_id = {
                users: merged.map((u) => u.id),
              };

              this.axios.post(
                window.VUE_APP_MISTRA_URL +
                  "users/v2/role/" +
                  this.singleGroup.id +
                  "/users",
                users_id,
                { headers: this.he }
              );
            }

            setTimeout(() => {
              this.getGroups();
              this.getUsers(true);
            }, 500);

            this.viewGroup();
          }

          // Switch back to the Role panel without closing the sidebar to immediately reflect selected users
          this.panel = 1;
          this.viewPanel = true;
        }
      });
    },
    deleteGroup(group_id) {
      this.axios
        .delete(
          window.VUE_APP_MISTRA_URL +
            "users/v2/role/" +
            group_id,
          { headers: this.he }
        )
        .then(() => {
          this.getGroups();
          this.viewGroup();
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    resetUsersGroup() {
      this.usersGroup = [];
    },
    addUsersGroup(index) {
      this.singleGroup = this.dataFilterGroups[index];
      this.panel = 4;
      this.viewPanel = true;
      this.ctrlPanelUsersSearch = true;
      // Close any open role sub menus to avoid overlaying the form
      this.viewGroup();
    },
    noEdit(group_name) {
      if (group_name.toLowerCase() == "admin") {
        return false;
      }
      return true;
    },
    getIsAdmin() {
      let userLoggedStore = useUserStore();
      if (
        userLoggedStore.user &&
        userLoggedStore.user.role &&
        userLoggedStore.user.role.name.toLowerCase() == "admin"
      ) {
        this.isAdmin = true;
        return;
      }
      this.isAdmin = false;
      return;
    },
    ctrlPerms(perms) {
      return this.$ctrlPermissions(perms);
    },
    getColorRole(color) {
      return color != "" ? color : "6585a7";
    },
    getPermissionForDirectUser(page, permission) {
      let isPage = page == permission;
      let userInfo = useUserStore();
      if (!userInfo.user.is_partner && isPage) {
        return false;
      }
      return true;
    },
    checkPermissions(permissions, pages, isParentContainer = false) {
      let permissionsArrayValues = Object.values(permissions);
      let pagesArrayValues = Object.values(pages);

      let checkPages;
      if (isParentContainer) {
        // For parent containers: show if user has ANY of the required permissions
        checkPages = permissionsArrayValues.some((valore) =>
          pagesArrayValues.some((el) => el.name === valore)
        );
      } else {
        // For leaf items: check if ALL required permissions are present in user's pages
        checkPages = permissionsArrayValues.every((valore) =>
          pagesArrayValues.some((el) => el.name === valore)
        );
      }
      return checkPages;
    },
    getAllPages() {
      this.axios
        .get(
          window.VUE_APP_MISTRA_URL +
            "users/v2/page?page_number=1&disable_pagination=true",
          { headers: this.he }
        )
        .then((rls) => {
          this.pages = rls.data.items;
        });
    },
    getHeader() {
      return {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      };
    },
    viewBiometric(index = -1) {
      const subInfoBiometric =
        document.getElementsByClassName("subInfoBiometric");

      for (let i = 0; i < subInfoBiometric.length; i++) {
        if (index !== i) {
          subInfoBiometric[i].classList.remove("active");
        }
      }

      const dropdown = document.getElementsByClassName(
        "subInfoBiometric-" + index
      )[0];
      if (index > -1 && dropdown) {
        dropdown.classList.toggle("active");
      }
    },
    requestBiometricAccess(ctrl) {
      window.scrollTo(0, 0);
      this.singleUser = this.dataFilter[ctrl];
      this.singleUser.ctrl = ctrl;
      this.viewBiometricRequestModal = true;
      if (this.viewBiometricRequestModal) {
        document.getElementsByTagName("body")[0].classList.add("overflow");
      }
      this.viewBiometric(ctrl);
    },
    revokeBiometricAccess(ctrl) {
      window.scrollTo(0, 0);
      this.singleUser = this.dataFilter[ctrl];
      this.singleUser.ctrl = ctrl;
      this.viewBiometricRevokeModal = true;
      if (this.viewBiometricRevokeModal) {
        document.getElementsByTagName("body")[0].classList.add("overflow");
      }
      this.viewBiometric(ctrl);
    },
    async confirmBiometricRequest() {
      const index = this.singleUser.ctrl;
      if (index !== undefined && this.dataFilter[index]) {
        this.setBiometricPending(index, "activation");

        try {
          const url =
            window.VUE_APP_MISTRA_URL +
            `users/v2/user/${this.dataFilter[index].id}/biometric/activate`;
          await this.axios.post(url, {}, { headers: this.getHeader() });
        } catch (error) {
          console.error(
            "Error submitting biometric activation request:",
            error
          );
          this.revertBiometricPending(index);
        }
      }
      this.closeBiometricRequestModal();
    },
    async confirmBiometricRevoke() {
      const index = this.singleUser.ctrl;
      if (index !== undefined && this.dataFilter[index]) {
        this.setBiometricPending(index, "deactivation");

        try {
          const url =
            window.VUE_APP_MISTRA_URL +
            `users/v2/user/${this.dataFilter[index].id}/biometric/deactivate`;
          await this.axios.post(url, {}, { headers: this.getHeader() });
        } catch (error) {
          console.error(
            "Error submitting biometric deactivation request:",
            error
          );
          this.revertBiometricPending(index);
        }
      }
      this.closeBiometricRevokeModal();
    },
    setBiometricPending(index, requestType = null) {
      const target = this.dataFilter[index];
      if (!target) {
        return;
      }
      const pendingRequest = requestType
        ? { type: requestType, completed: false }
        : null;
      this.syncBiometricState(target, { request: pendingRequest });
      const userIndex = this.users.findIndex((u) => u.id === target.id);
      if (userIndex !== -1) {
        this.syncBiometricState(this.users[userIndex], {
          request: pendingRequest,
        });
      }
    },
    async checkColocationAccess(headers) {
      try {
        const response = await this.axios.get(
          window.VUE_APP_MISTRA_URL +
            "assets/v1/has-assets/colocation",
          { headers }
        );

        const hasAssets = !!(response?.data?.hasAssets);

        if (!hasAssets) {
          this.forbiddenMessage = this.$t("noSolutionsServices.colocation");
        }

        return hasAssets;
      } catch (error) {
        const status = error?.response?.status ?? error?.request?.status;

        if (status === 403) {
          this.forbiddenMessage = this.$t("noSolutionsServices.colocation");
          return false;
        }

        console.error("Error checking colocation assets:", error);
        return true;
      }
    },
    revertBiometricPending(index) {
      const target = this.dataFilter[index];
      if (!target) {
        return;
      }
      this.syncBiometricState(target, { request: null });
      const userIndex = this.users.findIndex((u) => u.id === target.id);
      if (userIndex !== -1) {
        this.syncBiometricState(this.users[userIndex], { request: null });
      }
    },
    closeBiometricRequestModal() {
      this.viewBiometricRequestModal = false;
      document.getElementsByTagName("body")[0].classList.remove("overflow");
    },
    closeBiometricRevokeModal() {
      this.viewBiometricRevokeModal = false;
      document.getElementsByTagName("body")[0].classList.remove("overflow");
    },
    syncBiometricState(user, overrides = {}) {
      if (!user) {
        return;
      }
      const normalizeRequest = (value) => {
        if (!value) {
          return null;
        }
        if (typeof value === "string") {
          return { type: value, completed: false };
        }
        if (typeof value === "object") {
          const normalizedType = value.type ?? null;
          if (!normalizedType) {
            return null;
          }
          const normalizedCompleted =
            typeof value.completed === "boolean"
              ? value.completed
              : value.completed == null
              ? false
              : !!value.completed;
          return {
            type: normalizedType,
            completed: normalizedCompleted,
          };
        }
        return null;
      };

      const biometricSource =
        user.biometric && typeof user.biometric === "object"
          ? user.biometric
          : {};
      const hasOverride = (key) =>
        Object.prototype.hasOwnProperty.call(overrides, key);

      const normalizedIsBiometric = (() => {
        if (hasOverride("is_bio")) {
          return !!overrides.is_bio;
        }
        if (hasOverride("is_biometric")) {
          return !!overrides.is_biometric;
        }
        if (Object.prototype.hasOwnProperty.call(biometricSource, "is_bio")) {
          return !!biometricSource.is_bio;
        }
        if (
          Object.prototype.hasOwnProperty.call(biometricSource, "is_biometric")
        ) {
          return !!biometricSource.is_biometric;
        }
        return !!(user.is_biometric ?? user.biometricEnabled ?? false);
      })();

      const overrideRequest = hasOverride("request")
        ? overrides.request
        : hasOverride("biometric_request")
        ? overrides.biometric_request
        : undefined;

      const normalizedRequest =
        typeof overrideRequest !== "undefined"
          ? normalizeRequest(overrideRequest)
          : biometricSource.request
          ? normalizeRequest(biometricSource.request)
          : user.biometric_request
          ? normalizeRequest(user.biometric_request)
          : null;

      user.biometric = {
        ...biometricSource,
        is_bio: normalizedIsBiometric,
        request: normalizedRequest,
      };
      user.is_biometric = normalizedIsBiometric;
      user.biometric_request = normalizedRequest;

      let status = normalizedIsBiometric ? "enabled" : "disabled";
      if (normalizedRequest && normalizedRequest.type) {
        const isActivation = normalizedRequest.type === "activation";
        const isDeactivation = normalizedRequest.type === "deactivation";

        const pendingActivation =
          isActivation &&
          (!normalizedRequest.completed || normalizedIsBiometric === false);
        const pendingDeactivation =
          isDeactivation &&
          (!normalizedRequest.completed || normalizedIsBiometric === true);

        if (pendingActivation) {
          // Fallback: activation request marked complete but flag not yet true should stay visible
          status = "pending_activation";
        } else if (pendingDeactivation) {
          // Fallback: deactivation request marked complete but flag not yet cleared
          status = "pending_deactivation";
        }
      }
      user.bio_req_status = status;
    },
    getBiometricLegendTooltip() {
      return this.$t("users.biometricTooltipLegend");
    },
    getBiometricDotColor(user) {
      const PENDING_ACTIVATION_COLOR = "#ffd200"; // yellow
      const PENDING_DEACTIVATION_COLOR = "#ff8c00"; // orange

      if (user && typeof user.bio_req_status === "undefined") {
        this.syncBiometricState(user);
      }

      switch (user?.bio_req_status) {
        case "pending_activation":
          return PENDING_ACTIVATION_COLOR;
        case "pending_deactivation":
          return PENDING_DEACTIVATION_COLOR;
        default:
          return user?.is_biometric ? "#28a745" : "#6c757d";
      }
    },
    isBiometricPending(user, expectedType = null) {
      if (!user) {
        return false;
      }
      if (typeof user.bio_req_status === "undefined") {
        this.syncBiometricState(user);
      }
      const pendingActivation = user.bio_req_status === "pending_activation";
      const pendingDeactivation =
        user.bio_req_status === "pending_deactivation";
      if (expectedType === "activation") {
        return pendingActivation;
      }
      if (expectedType === "deactivation") {
        return pendingDeactivation;
      }
      return pendingActivation || pendingDeactivation;
    },
    handleClickOutside(event) {
      const biometricDropdowns =
        document.getElementsByClassName("subInfoBiometric");
      const biometricButtons = document.querySelectorAll(
        '[id*="user-fingerprint-"]'
      );

      let clickedInsideDropdown = false;
      let clickedOnButton = false;

      for (let i = 0; i < biometricDropdowns.length; i++) {
        if (biometricDropdowns[i].contains(event.target)) {
          clickedInsideDropdown = true;
          break;
        }
      }

      biometricButtons.forEach((button) => {
        if (button.contains(event.target)) {
          clickedOnButton = true;
        }
      });

      if (!clickedInsideDropdown && !clickedOnButton) {
        this.viewBiometric(-1);
      }
    },
  },
  beforeUnmount() {
    this.getIsAdmin();
    // Clean up role click-outside listener if still attached
    if (typeof this.removeRoleClickOutsideListener === "function") {
      this.removeRoleClickOutsideListener();
    }
    document.removeEventListener("click", this.handleClickOutside);
  },
  async mounted() {
    // this.getIsAdmin();
    let he = {
      Accept: "application/json",
      Authorization: "Bearer " + this.$keycloak.idToken,
    };

    const hasColocation = await this.checkColocationAccess(he);

    if(hasColocation){
      this.showBiometric=true
    }else{
      this.showBiometric=false
    }
    this.getUsers();
    this.getGroups();
    this.getAllPages();
    document.addEventListener("click", this.handleClickOutside);
  }
};
</script>
